// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const uniq = require('lodash/array/uniq');
const { withRouter } = require('react-router-dom');

// @core
const { formatText } = require('core/i18n').i18n;

// @components
import PopoverNavigationButton from 'components/commons/popoverNavigationButton/popoverNavigationButton'
//@constants
const ACCOUNTS_PRODUCT_BANNERS = require ('constants/productBanners/accountsProductBanners');
const WELCOME_ACCOUNT_NAME = 'welcomeAccount';
const WELCOME_PAYROLL_ACCOUNT_NAME = 'welcomePayrollAccount';
const {
    ACCOUNT_TYPE_SUBTYPE_PAYROLL,
    CHECKING_ACCOUNT_TYPE,
    OPENYOUNG_ACCOUNT_FULLTYPE,
    OPEN_YOUNG_PACK_KEY
} = require('constants/index.js')
const {
    CHECKING_ACCOUNT,
    DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT,
    OPEN_YOUNG,
    PAYROLL_ACCOUNT,
    WELCOME_ACCOUNT,
    WELCOME_PAYROLL_ACCOUNT,
    OPEN_YOUNG_PACK
} = require('constants/flagBasedFeatures');
const { COUNTRIES_CODES: { ES } } = require('constants/countries');
//@utilities
const { nonNumericFilter } = require('utilities/stringHelper');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class AccountsProductDropdown extends React.PureComponent {
    constructor(props){
        super(props)

        if (this.props.isNerudaUser){
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER = [
                CHECKING_ACCOUNT_TYPE, // Cuenta Corriente
                ACCOUNT_TYPE_SUBTYPE_PAYROLL, //Cuenta Corriente Nomina
            ];
        }else{
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER = [ //(nicolas.olmos): Order defined on US.
                ACCOUNT_TYPE_SUBTYPE_PAYROLL, //Cuenta Corriente Nomina
                '301', // Cuenta Ahorro
                '301101', // Cuenta Ahorro Openyoung/Junior
                OPEN_YOUNG_PACK_KEY, // Pack Open Young
                CHECKING_ACCOUNT_TYPE, // Cuenta Corriente,
                WELCOME_ACCOUNT_NAME, // Cuenta Ahorro Bienvenida
                WELCOME_PAYROLL_ACCOUNT_NAME // Cuenta Ahorro Bienvenida Nomina
            ];
        }
    }

    getUserOwnedProductBannersCode = () => {
        const { immAccounts } = this.props
        const output = [];

        immAccounts.get('byId').forEach(immAccount => {
            const product = immAccount.get('newProduct');
            const subproduct = immAccount.get('accountType');

            if (product !== '100') { // immAccount isn't a "credito de inversion".
                const accountCodeType = nonNumericFilter(product + subproduct);
                if (accountCodeType === '300805' || accountCodeType === '301101') {
                    output.push(accountCodeType);
                } else {
                    output.push(product);
                }
            }
        });

        return uniq(output);
    }

    getProductBannersOrder(userAccountAdvertisementTypes) {
        const accountTypesContractedByUser = [];
        const accountTypesNonContractedByUser = [];

        this.ACCOUNTS_PRODUCT_BANNERS_ORDER.forEach(accountType => {
            if (userAccountAdvertisementTypes.includes(accountType)) {
                accountTypesContractedByUser.push(accountType);
            } else {
                accountTypesNonContractedByUser.push(accountType);
            }
        })

        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    showAccountProductByFeatureToggling = identifier => {
        const { flagBasedFeatures } = this.props
        let response = true
        switch (identifier) {
            case OPEN_YOUNG_PACK_KEY:
                response = flagBasedFeatures.get(OPEN_YOUNG_PACK)
                break;
            case OPENYOUNG_ACCOUNT_FULLTYPE:
                response = flagBasedFeatures.get(OPEN_YOUNG)
                break;
            case ACCOUNT_TYPE_SUBTYPE_PAYROLL:
                response = flagBasedFeatures.get(PAYROLL_ACCOUNT)
                break;
            case CHECKING_ACCOUNT_TYPE:
                response = flagBasedFeatures.get(CHECKING_ACCOUNT)
                break;
            case WELCOME_ACCOUNT_NAME:
                response = flagBasedFeatures.get(WELCOME_ACCOUNT)
                break;
            case WELCOME_PAYROLL_ACCOUNT_NAME:
                response = flagBasedFeatures.get(WELCOME_PAYROLL_ACCOUNT)
                break;
            default:
                response = true
                break;
        }

        return response
    }

    clickHandler = (link) => {
        const {
            flagBasedFeatures,
            history,
            immHiringProductBanners,
            showAccountBlockedErrorModal
        } = this.props

        const blockedAccountFlag = flagBasedFeatures.get(DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT);
        if (blockedAccountFlag) {
            immHiringProductBanners.get('isAccountBlockedValidationError')
            && !immHiringProductBanners.get('isAccountBlockedValidationFetching')
            && showAccountBlockedErrorModal(true);
            immHiringProductBanners.get('isAccountBlockedValidationSuccess') && history.push(link);
        } else if (!blockedAccountFlag) {
           history.push(link);
        }
    }

    buildProductDropdown = (orderedProductBanners) => {
        const {
            flagBasedFeatures,
            immProfile,
            offers
        } = this.props
        const title = formatText('accountsHiringDropdown-title');
        const originCountry = immProfile.get('originCountry');

        const filteredItems = orderedProductBanners.filter( bannerKey =>
            this.showAccountProductByFeatureToggling(bannerKey)
        );
        
        const allBanners = {
            ...ACCOUNTS_PRODUCT_BANNERS,
            ...(offers.offerBanner ? offers.offerBanner : {}),
        };
        
        const filteredCountryItems = filteredItems.filter(bannerKey => {
            return (((bannerKey !== WELCOME_PAYROLL_ACCOUNT_NAME) || (bannerKey === WELCOME_PAYROLL_ACCOUNT_NAME && originCountry === ES)) && !!allBanners[bannerKey] && !allBanners[bannerKey].isError);
        });
        const items = filteredCountryItems.map(bannerKey => {
            const banner = allBanners[bannerKey];
            const link = banner.link;

            return {
                text: formatText(banner.title),
                handleClick: () => this.clickHandler(link),
                disabled: (banner.featureTogglingKey && !flagBasedFeatures.get(banner.featureTogglingKey))
            };
        });

        const finalItems = items.filter(item => !item.disabled)
        return (
            <PopoverNavigationButton
                title={title}
                items={finalItems}
            />
        );
    }

    render() {
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode();
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode);
        return this.buildProductDropdown(orderedProductBanners);
    }
}

AccountsProductDropdown.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immHiringProductBanners: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    isNerudaUser: PropTypes.bool.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    offers: PropTypes.object.isRequired,
    showAccountBlockedErrorModal: PropTypes.func
}

module.exports = withFeatureToggling(withRouter(AccountsProductDropdown));
